import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import ModalHeader from '../components/ModalHeader';
import useFireClientEvent from '../hooks/useFireClientEvent';
import useLinkNavigate from '../hooks/useLinkNavigate';
import { selectLoadedPlatform } from '../state/slices/slice-link-api';
import { selectLinkParams } from '../state/slices/slice-link-params';
import { AmountFromToken, FullSwitchAndMore, Legacy, RemoveAllocations, } from '../views/AmountSelection';
export var getAmountSelectionType = function (linkParams, loadedPlatform) {
    if (!linkParams) {
        return 'Legacy';
    }
    var linkTokenPayload = linkParams.linkTokenPayload;
    var amount = linkTokenPayload.amount, allocation = linkTokenPayload.allocation;
    if (amount || ((allocation === null || allocation === void 0 ? void 0 : allocation.type) === 'amount' && allocation.value !== 0))
        return 'AmountFromToken';
    if (amount === 0 || (allocation === null || allocation === void 0 ? void 0 : allocation.value) === 0)
        return 'RemoveAllocations';
    // DD forms search entrypoint - loadedPlatform is not defined so default to full switch
    if (!loadedPlatform || (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.fullSwitchSupported))
        return 'FullSwitchAndMore';
    return 'Legacy';
};
export var getAmountSelectionElement = function (linkParams, loadedPlatform) {
    var amountSelectionType = getAmountSelectionType(linkParams, loadedPlatform);
    if (amountSelectionType === 'AmountFromToken')
        return AmountFromToken;
    if (amountSelectionType === 'RemoveAllocations')
        return RemoveAllocations;
    if (amountSelectionType === 'FullSwitchAndMore')
        return FullSwitchAndMore;
    return Legacy;
};
var AmountSelection = function () {
    var navigate = useLinkNavigate();
    var linkParams = useSelector(selectLinkParams);
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var AmountSelectionElement = getAmountSelectionElement(linkParams, loadedPlatform);
    var fireClientEvent = useFireClientEvent();
    var handleContinue = function () {
        if (linkParams.linkTokenPayload.enableUserInputBankInfo) {
            return navigate('/bank-info-input');
        }
        if (linkParams.experiments.confirmationScreenEnabled) {
            return navigate('/switch-confirmation');
        }
        return navigate('/link-api/dds');
    };
    useEffect(function () {
        if (getAmountSelectionType(linkParams, loadedPlatform) ===
            'AmountFromToken' &&
            linkParams.experiments.confirmationScreenEnabled &&
            !linkParams.linkTokenPayload.enableUserInputBankInfo) {
            handleContinue();
        }
        else
            fireClientEvent('input_required');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkParams, loadedPlatform]);
    return (React.createElement(ScreenContainer, { "data-testid": "amount-selection" },
        React.createElement(ModalHeader, { showPlatformLogo: true, hideBackButton: true }),
        React.createElement(ContentFrame, null,
            React.createElement(AmountSelectionElement, { onContinue: handleContinue }))));
};
export default AmountSelection;
